@if (obser$ | async; as obser) {
  <form (ngSubmit)="onSubmit()" [title]="title" [formGroup]="form">
    <div class="row">
      <div class="col-md-12">
        @if (!form.get('id')?.value) {
          <pr-file
            (fileChange)="onLoadFiles($event)"
            [form]="true"
            [fileForm]="file"
            [gedAccountId]="user?.accountId"
            [gedDocuments]="gedDocuments"
            (gedDocumentSelected)="onGedDocumentSelected($event)"
          ></pr-file>
        }
      </div>
      <div class="col-md-12">
        @if (form.get('id')?.value) {
          <ged-document-card
            [doc]="entity"
            [accountId]="user?.accountId"
            [documents]="gedDocuments"
            (pick)="onGedDocumentSelected($event)"
            (withdraw)="withdraw()"
            (remove)="deleteDocument(entity)"
          ></ged-document-card>
        }
        @if (error != null) {
          <div class="alert alert-danger" style="margin-top: 20px" role="alert">
            {{ error }}
          </div>
        }
      </div>
      <div class="col-md-12">
        <div style="max-height: none; margin-top: 1rem; position: relative">
          <div>
            @if (displayDocumentLoading) {
              <pr-loader style="max-height: 0rem; margin-top: 7rem"></pr-loader>
            }
          </div>
          @if (safeUrl) {
            <iframe [src]="safeUrl" width="100%" height="700" frameborder="0">
            </iframe>
          }
        </div>
      </div>
    </div>
    <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
  </form>
}
@if (loading) {
  <pr-loader></pr-loader>
}
